import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import { captureApiException } from '@/utility/sentry'

export const useDynamicPopupStore = defineStore('dynamicPopupStore', () => {

    const popupData = ref([])
    const abortController = ref(null)
    
    async function getDynamicPopup (path) {

        if (abortController.value)
            abortController.value.abort()

        const currentController = new AbortController()
        abortController.value = currentController
        const requestSignal = currentController.signal

        const headers = {
            Authorization: 'Bearer ' + localStorage.getItem('id_token_portalbitrix')
        }

        try {
            const response = await axios.get(import.meta.env.VITE_BITRIXAPI + 'partner/dynamicPopup?page=' + path, { headers, signal: requestSignal })
            const popups = response.data.data

            let popupArr = []
            
            if (popups.length < 1)
                return false

            await popups.forEach((item, index) => {

                const popupItem = {
                    ID: item.ID,
                    POPUP_LOG_ID: item.POPUP_LOG_ID,
                    TRANSITION_INTERVAL: null,
                    MAX_SHOW: item.MAX_SHOW,
                    SEEN: false,
                    SEEN_THE_LAST_INDEX: false,
                    SEEN_COUNT: item.SEEN_COUNT,
                    TOTAL_STORY_ITEMS: item.STORY_ITEMS.length || 1,
                    SHOW_POPUP: false,
                    LOCATION: item.LOCATION,
                    DEVICE: item.DEVICE,
                    ENABLE_CLOSE: item.ENABLE_CLOSE,
                    BUTTON_ON_LAST: false,
                    STORY_ITEMS: []
                }

                if (item.SHOW_POPUP && item.SEEN_COUNT < item.MAX_SHOW) {
                    const storyItem = []

                    if (item.STORY_ITEMS.length == 0) {

                        const singlePopup = item
                        singlePopup.ITEM_INDEX = 0

                        popupItem.STORY_ITEMS.push(item)

                    } else {
                        // if the story items are not empty
                        const mappedItems = item.STORY_ITEMS.map((storyItem, index) => ({ 
                            ...storyItem, 
                            ITEM_INDEX: index 
                        }))


                        mappedItems.forEach((storyItem, idx) => {

                            if (storyItem['VIDEO_URL']) {
                                const paramArray = storyItem['VIDEO_URL'].split("?")[1].split("&").map(param => param.split("="))
                                const dataArr = Object.fromEntries(paramArray)

                                storyItem['VIDEO_URL_TO_PLAY'] = `https://www.youtube.com/embed/${dataArr.v}?rel=0&controls=0&autoplay=1`
                                storyItem['VIDEO_URL_AUTOPLAY'] = false
                            }

                            // check the last index of the story item
                            if ((item.STORY_ITEMS.length - 1) == idx && item.REDIRECT_URL != 'null')
                                popupItem.BUTTON_ON_LAST = true
                        })

                        // for 1 items
                        if (mappedItems.length == 1) {
                            popupItem.STORY_ITEMS.push(
                                ...mappedItems
                            )
                        }

                        // for 2 items
                        if (mappedItems.length == 2) {
                            popupItem.STORY_ITEMS.push(
                                { ...mappedItems[mappedItems.length - 1], ITEM_INDEX: mappedItems.length + 1 },
                                ...mappedItems.map((item, index) => ({ ...item, ITEM_INDEX: index })),
                                { ...mappedItems[0], ITEM_INDEX: mappedItems.length }
                            )
                        }

                        // for more than 2
                        if (mappedItems.length > 2) {
                            popupItem.STORY_ITEMS.push(
                                { ...mappedItems[mappedItems.length - 1] },
                                ...mappedItems.slice(0, -1)
                            )
                        }

                    }
                    
                    popupArr.push(popupItem)
                }
 
            })

            popupData.value = popupArr
            // console.log(popupArr)

        } catch (error) {
            
            if (axios.isCancel(error))
                return

            captureApiException(error, 'dynamicPopup.js', 'getDynamicPopup')
            console.error(error)
        } finally {
            if (abortController.value === currentController)
                abortController.value = null
        }
    }

    async function seenDynamicPopup (id) {
        const headers = {
            Authorization: 'Bearer ' + localStorage.getItem('id_token_portalbitrix')
        }
        const data = {}
        
        try {
            const response = await axios.put(import.meta.env.VITE_BITRIXAPI + 'partner/markDynamicPopupSeen/' + id, data, { headers })
        } catch (error) {
            captureApiException(error, 'dynamicPopup.vue', 'seenDynamicPopup')
            console.error(error)
        }
    }

    async function abortDynamicPopup () {
        if (abortController.value)
            abortController.value.abort()

        abortController.value = new AbortController()
        const requestSignal = abortController.value.signal
    }

    return {
        popupData,
        getDynamicPopup, seenDynamicPopup, seenDynamicPopup, abortDynamicPopup
    }
})